import { useContext } from "react"
import { UserContext } from "../context/userContext"
import { LoaderMedium } from "./Loaders"
import styles from "../styles/AllParticipantsSummary.module.css"

import { gql, useQuery } from "@apollo/client"

export default function MyParticipantsSummary() {
  const userCtx = useContext(UserContext)

  const GET_PARTICIPANTS = gql`
    query myParticipantsStats($staff_id: ID!, $organization_id: ID!) {
      myParticipantsStats(
        staff_id: $staff_id
        organization_id: $organization_id
        type: "my_participants"
      ) {
        currently_assigned
        currently_unassigned
        engaged
        unengaged
        inactive
      }
    }
  `
  const { data, loading } = useQuery(GET_PARTICIPANTS, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
    },
    fetchPolicy: "network-only",
    skip: !userCtx,
  })

  if (loading) {
    return (
      <div className={styles.card}>
        <LoaderMedium />
      </div>
    )
  }

  const stats = data?.myParticipantsStats || {}
  const rows = [
    { label: "Currently Assigned", value: stats.currently_assigned ?? 0 },
    { label: "Engaged", value: stats.engaged ?? 0 },
    { label: "Unengaged", value: stats.unengaged ?? 0 },
  ]

  return (
    <section className={styles.card}>
      <div className={styles.headerRow}>
        <h3 className="sidebar-section-title">My Participants</h3>
      </div>

      <div className={styles.body}>
        {rows.map((row) => (
          <div key={row.label} className={styles.infoLine}>
            <span className={styles.lineLabel}>{row.label}</span>
            <span className={styles.countPill}>{row.value}</span>
          </div>
        ))}
      </div>
    </section>
  )
}
